import { GAME_ID, REDUX_ACTIONS } from '../../data/constants';

const initialState = {
  isNotebookVisible: false,
  notebookCount: 0,
  hintCounts: {
    character: 0,
    where: 0,
    when: 0,
    problem: 0,
    event: 0,
    resolution: 0,
  },
};

const hintTrackingReducer = (state = initialState, { type, payload, gameId }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.SET_LEVEL_ID:
    case REDUX_ACTIONS.NEXT_STANDARD_ITEM:
      return {
        ...initialState,
      };

    case REDUX_ACTIONS.TOGGLE_DIARY_PANEL:
      return {
        ...state,
        isNotebookVisible: !state.isNotebookVisible,
        notebookCount: state.isNotebookVisible ? state.notebookCount : state.notebookCount + 1,
      };

    case REDUX_ACTIONS.PRESS_QUESTION_MARK: {
      const hintCounts = { ...state.hintCounts };
      hintCounts[payload.nameInCurriculum] += 1;
      return {
        ...state,
        hintCounts,
      };
    }

    default:
      return state;
  }
};

export default hintTrackingReducer;
